<template>
    <div id="onboard" class="p-5">

        <div v-if="loaded">

            <div class="d-flex align-items-center gap-20 mb-3">
                <v-img :src="publicPath + 'images/logo_dahub_white.png'" class="logo"></v-img>

                <div class="page-title text-white">
                    Configuration de votre compte
                </div>
            </div>

            <v-stepper v-model="currentStep" non-linear>
                <v-stepper-header>
                    <v-stepper-step v-for="step in steps" :step="step.index" editable @click="checkStep">
                        {{ step.name }}
                    </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content step="1">
                        <organism></organism>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <team></team>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                        <sender></sender>
                    </v-stepper-content>

                    <v-stepper-content step="4">
                        <finalize></finalize>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </div>
    </div>
</template>

<script>
import Organism from "./steps/Organism"
import Team from "./steps/Team"
import Sender from "./steps/Sender"
import Referential from "./steps/Referential"
import Finalize from "./steps/Finalize"
import {mapState} from "vuex";
export default {
    name: "Onboard",
    components: { Finalize, Referential, Sender, Team, Organism },
    data() {
        return {
            steps: [],
            currentStep: 1,
            loaded: false,
            publicPath: process.env.BASE_URL
        }
    },
    methods: {
        getConfig() {
            const promise1 = this.$store.dispatch('account/getCredentials')
            const promise2 = this.$store.dispatch('account/loadSenders', false)

            Promise.all([promise1, promise2]).then((values) => {
                setTimeout(() => {
                    this.loaded = true
                    this.$global.loading = false
                }, 100)
            })
        },
        checkStep() {
            if (this.currentStep == 1) {
                this.$global.$emit('update-organism')
            }
        }
    },
    computed: {
        ...mapState('account', ['account', 'vtContract']),
    },
    created() {
        this.$global.loading = true

        let params = this.$route.query

        if (params.step !== undefined) {
            this.currentStep = params.step
        }

        this.getConfig()

        this.$global.$on('saved-config', () => {
            this.getConfig()
        })

        this.$global.$on('saved-config-no-loader', () => {
            this.getConfig(false)
        })

        this.$global.$on('change-step', (step) => {
            this.currentStep = step
        })

        this.steps.push({ name: 'Structure', index: 1})
        this.steps.push({ name: 'Equipe', index: 2})
        this.steps.push({ name: 'Boîtes d\'envois', index: 3})
        this.steps.push({ name: 'Finaliser', index: 4})

    },
    destroyed() {
        this.$global.$off('saved-config')
        this.$global.$off('saved-config-no-loader')
        this.$global.$off('change-step')
    }
}
</script>
